const translations = {
  ru: {
    // Header nav
    "nav.catalog": "Каталог",
    "nav.advantages": "Преимущества",
    "nav.reviews": "Отзывы",
    // Hero
    "hero.badge": "Доставка сегодня",
    "hero.title": "Доставка цветов",
    "hero.subtitle": "Закажите букет {city} с доставкой в день заказа. Фото перед отправкой. Оплата удобным способом.",
    "hero.orders": "10,000+ заказов",
    "hero.online": "Онлайн",
    "hero.otherCity": "Нет вашего города?",
    "hero.otherCityAction": "Доставим под заказ",
    "wa.otherCity": "Здравствуйте! Моего города нет на сайте — можно ли заказать доставку цветов в другой город?",
    // Products
    "products.title": "Наши",
    "products.titleAccent": "букеты",
    "products.subtitle": "Закажите свежие цветы с доставкой в день заказа",
    "products.order": "Заказать",
    "products.price": "Цена",
    "products.empty": "Каталог скоро будет доступен",
    "products.sort.asc": "Сначала дешёвые",
    "products.sort.desc": "Сначала дорогие",
    "products.all": "Все букеты",
    // Product Preview
    "preview.order": "Заказать в WhatsApp",
    "preview.telegram": "Telegram",
    "preview.close": "Закрыть",
    // Categories
    "cat.all": "Все",
    "cat.standard": "Стандарт",
    "cat.medium": "Медиум",
    "cat.premium": "Премиум",
    // Advantages
    "adv.title": "Почему выбирают",
    "adv.titleAccent": "нас",
    "adv.delivery.title": "Быстрая доставка",
    "adv.delivery.desc": "Доставим букет в день заказа в любой район города",
    "adv.fresh.title": "Свежие цветы",
    "adv.fresh.desc": "Только свежие цветы от проверенных поставщиков",
    "adv.photo.title": "Фото перед отправкой",
    "adv.photo.desc": "Отправим фото готового букета для согласования",
    "adv.payment.title": "Удобная оплата",
    "adv.payment.desc": "Принимаем оплату на карты любых банков и в любой валюте",
    // Reviews
    "rev.badge": "Реальные переписки",
    "rev.title": "Отзывы",
    "rev.titleAccent": "клиентов",
    "rev.subtitle": "Скриншоты реальных переписок с нашими клиентами",
    // CTA / Subscription
    "cta.badge": "Подписка на цветы",
    "cta.title": "Цветы по",
    "cta.titleAccent": "подписке",
    "cta.subtitle": "Регулярная доставка свежих букетов — выберите формат, который подходит именно вам",
    "cta.standard.title": "Стандарт",
    "cta.standard.desc": "Полный контроль — выбирайте бюджет и график доставки",
    "cta.standard.f1": "Вы выбираете стоимость букетов",
    "cta.standard.f2": "Выбираете частоту: раз в неделю, две или месяц",
    "cta.standard.f3": "Указываете удобный день и время доставки",
    "cta.standard.f4": "Фото букета перед каждой отправкой",
    "cta.standard.f5": "Гибкая настройка — меняйте параметры в любое время",
    "cta.standard.msg": "Здравствуйте! Интересует стандарт-подписка на цветы",
    "cta.surprise.badge": "Популярный выбор",
    "cta.surprise.title": "Сюрприз",
    "cta.surprise.desc": "Доверьтесь нашим флористам — мы удивим вас и получателя",
    "cta.surprise.f1": "Вы вносите депозит на выбранную сумму",
    "cta.surprise.f2": "Мы собираем букеты из лучших сезонных цветов",
    "cta.surprise.f3": "Доставка в течение выбранного вами срока",
    "cta.surprise.f4": "Согласование с получателем по времени",
    "cta.surprise.f5": "Каждый букет — уникальный сюрприз",
    "cta.surprise.msg": "Здравствуйте! Интересует сюрприз-подписка на цветы",
    "cta.footer": "Отмена подписки в любой момент · Бесплатная доставка · Без скрытых платежей",
    // FAQ
    "faq.badge": "FAQ",
    "faq.title": "Частые",
    "faq.titleAccent": "вопросы",
    // Footer
    "footer.desc": "Доставка свежих цветов {city}. Букеты на любой случай с доставкой в день заказа.",
    "footer.whatsapp": "Написать в WhatsApp",
    "footer.contacts": "Контакты",
    "footer.info": "Информация",
    "footer.sameDay": "Доставка в день заказа",
    "footer.anyPayment": "Оплата любой валютой на любые карты",
    "footer.copy": "Сделано с",
    "footer.delivery": "Доставка цветов {city}",
    // WhatsApp messages
    "wa.order": "Здравствуйте! Хочу заказать \"{name}\" за {price} ({city})",
    "wa.general": "Здравствуйте! Хочу заказать цветы с доставкой {city}",
    // Product alt
    "alt.product": "{name} — купить с доставкой {city}. Цена {price}",
    "alt.hero": "Доставка цветов {city} — YUCCA Flowers",
  },
  en: {
    "nav.catalog": "Catalog",
    "nav.advantages": "Benefits",
    "nav.reviews": "Reviews",
    "hero.badge": "Same day delivery",
    "hero.title": "Flower delivery",
    "hero.subtitle": "Order a bouquet {city} with same-day delivery. Photo before sending. Convenient payment options.",
    "hero.orders": "10,000+ orders",
    "hero.online": "Online",
    "hero.otherCity": "City not listed?",
    "hero.otherCityAction": "We deliver on request",
    "wa.otherCity": "Hello! My city isn't on the site — can you arrange flower delivery to another city?",
    "products.title": "Our",
    "products.titleAccent": "bouquets",
    "products.subtitle": "Order fresh flowers with same-day delivery",
    "products.order": "Order",
    "products.price": "Price",
    "products.empty": "Catalog coming soon",
    "products.sort.asc": "Price: low to high",
    "products.sort.desc": "Price: high to low",
    "products.all": "All bouquets",
    "preview.order": "Order via WhatsApp",
    "preview.telegram": "Telegram",
    "preview.close": "Close",
    "cat.all": "All",
    "cat.standard": "Standard",
    "cat.medium": "Medium",
    "cat.premium": "Premium",
    "adv.title": "Why choose",
    "adv.titleAccent": "us",
    "adv.delivery.title": "Fast delivery",
    "adv.delivery.desc": "Same-day delivery to any area of the city",
    "adv.fresh.title": "Fresh flowers",
    "adv.fresh.desc": "Only fresh flowers from trusted suppliers",
    "adv.photo.title": "Photo before delivery",
    "adv.photo.desc": "We'll send a photo of the bouquet for your approval",
    "adv.payment.title": "Easy payment",
    "adv.payment.desc": "We accept cards from any bank in any currency",
    "rev.badge": "Real conversations",
    "rev.title": "Customer",
    "rev.titleAccent": "reviews",
    "rev.subtitle": "Screenshots of real conversations with our customers",
    "cta.badge": "Flower subscription",
    "cta.title": "Flowers by",
    "cta.titleAccent": "subscription",
    "cta.subtitle": "Regular delivery of fresh bouquets — choose the format that suits you best",
    "cta.standard.title": "Standard",
    "cta.standard.desc": "Full control — choose your budget and delivery schedule",
    "cta.standard.f1": "You choose the bouquet price",
    "cta.standard.f2": "Select frequency: weekly, biweekly, or monthly",
    "cta.standard.f3": "Pick a convenient day and delivery time",
    "cta.standard.f4": "Photo of the bouquet before each delivery",
    "cta.standard.f5": "Flexible settings — change anytime",
    "cta.standard.msg": "Hello! I'm interested in a standard flower subscription",
    "cta.surprise.badge": "Popular choice",
    "cta.surprise.title": "Surprise",
    "cta.surprise.desc": "Trust our florists — we'll surprise you and the recipient",
    "cta.surprise.f1": "You make a deposit for the chosen amount",
    "cta.surprise.f2": "We create bouquets from the best seasonal flowers",
    "cta.surprise.f3": "Delivery within your chosen timeframe",
    "cta.surprise.f4": "We coordinate timing with the recipient",
    "cta.surprise.f5": "Every bouquet is a unique surprise",
    "cta.surprise.msg": "Hello! I'm interested in a surprise flower subscription",
    "cta.footer": "Cancel anytime · Free delivery · No hidden fees",
    "faq.badge": "FAQ",
    "faq.title": "Frequently asked",
    "faq.titleAccent": "questions",
    "footer.desc": "Fresh flower delivery {city}. Bouquets for any occasion with same-day delivery.",
    "footer.whatsapp": "Message on WhatsApp",
    "footer.contacts": "Contacts",
    "footer.info": "Information",
    "footer.sameDay": "Same-day delivery",
    "footer.anyPayment": "Payment in any currency to any card",
    "footer.copy": "Made with",
    "footer.delivery": "Flower delivery {city}",
    "wa.order": "Hello! I'd like to order \"{name}\" for {price} ({city})",
    "wa.general": "Hello! I'd like to order flowers with delivery {city}",
    "alt.product": "{name} — order with delivery {city}. Price {price}",
    "alt.hero": "Flower delivery {city} — YUCCA Flowers",
  },
  tr: {
    "nav.catalog": "Katalog",
    "nav.advantages": "Avantajlar",
    "nav.reviews": "Yorumlar",
    "hero.badge": "Aynı gün teslimat",
    "hero.title": "Çiçek teslimatı",
    "hero.subtitle": "{city} aynı gün teslimatla buket sipariş edin. Göndermeden önce fotoğraf. Uygun ödeme seçenekleri.",
    "hero.orders": "10.000+ sipariş",
    "hero.online": "Çevrimiçi",
    "hero.otherCity": "Şehriniz listede yok mu?",
    "hero.otherCityAction": "Talep üzerine teslim ederiz",
    "wa.otherCity": "Merhaba! Şehrim sitede yok — başka bir şehre çiçek teslimatı ayarlayabilir misiniz?",
    "products.title": "Bizim",
    "products.titleAccent": "buketlerimiz",
    "products.subtitle": "Aynı gün teslimatla taze çiçekler sipariş edin",
    "products.order": "Sipariş ver",
    "products.price": "Fiyat",
    "products.empty": "Katalog yakında kullanıma sunulacak",
    "products.sort.asc": "Fiyat: düşükten yükseğe",
    "products.sort.desc": "Fiyat: yüksekten düşüğe",
    "products.all": "Tüm buketler",
    "preview.order": "WhatsApp ile sipariş ver",
    "preview.telegram": "Telegram",
    "preview.close": "Kapat",
    "cat.all": "Tümü",
    "cat.standard": "Standart",
    "cat.medium": "Orta",
    "cat.premium": "Premium",
    "adv.title": "Neden bizi",
    "adv.titleAccent": "tercih ediyorlar",
    "adv.delivery.title": "Hızlı teslimat",
    "adv.delivery.desc": "Sipariş günü şehrin her bölgesine teslimat",
    "adv.fresh.title": "Taze çiçekler",
    "adv.fresh.desc": "Yalnızca güvenilir tedarikçilerden taze çiçekler",
    "adv.photo.title": "Göndermeden önce fotoğraf",
    "adv.photo.desc": "Onayınız için hazır buketin fotoğrafını göndeririz",
    "adv.payment.title": "Kolay ödeme",
    "adv.payment.desc": "Her bankadan her para biriminde kart kabul ediyoruz",
    "rev.badge": "Gerçek yazışmalar",
    "rev.title": "Müşteri",
    "rev.titleAccent": "yorumları",
    "rev.subtitle": "Müşterilerimizle gerçek yazışmaların ekran görüntüleri",
    "cta.badge": "Çiçek aboneliği",
    "cta.title": "Abonelikle",
    "cta.titleAccent": "çiçekler",
    "cta.subtitle": "Düzenli taze buket teslimatı — size en uygun formatı seçin",
    "cta.standard.title": "Standart",
    "cta.standard.desc": "Tam kontrol — bütçenizi ve teslimat programınızı seçin",
    "cta.standard.f1": "Buket fiyatını siz seçersiniz",
    "cta.standard.f2": "Sıklığı seçin: haftalık, iki haftada bir veya aylık",
    "cta.standard.f3": "Uygun gün ve teslimat saatini belirleyin",
    "cta.standard.f4": "Her gönderimden önce buket fotoğrafı",
    "cta.standard.f5": "Esnek ayarlar — istediğiniz zaman değiştirin",
    "cta.standard.msg": "Merhaba! Standart çiçek aboneliğiyle ilgileniyorum",
    "cta.surprise.badge": "Popüler seçim",
    "cta.surprise.title": "Sürpriz",
    "cta.surprise.desc": "Floristlerimize güvenin — sizi ve alıcıyı şaşırtacağız",
    "cta.surprise.f1": "Seçtiğiniz tutar için depozito yatırırsınız",
    "cta.surprise.f2": "En iyi mevsim çiçeklerinden buketler hazırlarız",
    "cta.surprise.f3": "Seçtiğiniz süre içinde teslimat",
    "cta.surprise.f4": "Alıcıyla zamanlama koordinasyonu",
    "cta.surprise.f5": "Her buket benzersiz bir sürpriz",
    "cta.surprise.msg": "Merhaba! Sürpriz çiçek aboneliğiyle ilgileniyorum",
    "cta.footer": "İstediğiniz zaman iptal · Ücretsiz teslimat · Gizli ücret yok",
    "faq.badge": "SSS",
    "faq.title": "Sık sorulan",
    "faq.titleAccent": "sorular",
    "footer.desc": "{city} taze çiçek teslimatı. Her vesileyle aynı gün teslimatla buketler.",
    "footer.whatsapp": "WhatsApp'tan yazın",
    "footer.contacts": "İletişim",
    "footer.info": "Bilgi",
    "footer.sameDay": "Aynı gün teslimat",
    "footer.anyPayment": "Her para biriminde her karta ödeme",
    "footer.copy": "Sevgiyle yapıldı",
    "footer.delivery": "Çiçek teslimatı {city}",
    "wa.order": "Merhaba! \"{name}\" buketini {price} fiyatla sipariş etmek istiyorum ({city})",
    "wa.general": "Merhaba! {city} teslimatla çiçek sipariş etmek istiyorum",
    "alt.product": "{name} — {city} teslimatla sipariş edin. Fiyat {price}",
    "alt.hero": "Çiçek teslimatı {city} — YUCCA Flowers",
  },
};

export const t = (key, lang = "ru", vars = {}) => {
  let text = translations[lang]?.[key] || translations.ru[key] || key;
  Object.entries(vars).forEach(([k, v]) => {
    text = text.replace(`{${k}}`, v);
  });
  return text;
};

export default translations;
